import { gql } from '@apollo/client'

export default gql`
  mutation replaceQuestion($id: ID!) {
    replaceQuestion(id: $id) {
      id
    }
  }
`
